function Services() {
  return (
    <section id="services" className="section">
      <h2>Our Expertise</h2>

      <div className="services-grid">
        <div className="service-card">
          <h3>Residential Projects</h3>
          <p>Elegant homes built with precision and care, tailored to your family's needs.</p>
        </div>

        <div className="service-card">
          <h3>Commercial Spaces</h3>
          <p>Functional and visually striking environments that drive business success.</p>
        </div>

        <div className="service-card">
          <h3>Interior Solutions</h3>
          <p>Modern interiors and bespoke furniture tailored to your unique lifestyle.</p>
        </div>

        <div className="service-card">
          <h3>Renovations</h3>
          <p>Transforming existing structures into beautiful, modern masterpieces.</p>
        </div>
      </div>
    </section>
  );
}

export default Services;